/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetCaseResourceByRole$Params {
  roleCode: string;
}

export function getCaseResourceByRole(http: HttpClient, rootUrl: string, params: GetCaseResourceByRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CaseResourceDto>>> {
  const rb = new RequestBuilder(rootUrl, getCaseResourceByRole.PATH, 'get');
  if (params) {
    rb.path('roleCode', params.roleCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CaseResourceDto>>;
    })
  );
}

getCaseResourceByRole.PATH = '/case-resources/roles/{roleCode}';
